/**
 * @desc 样品确认-提审
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.ProductConfirmCommitRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productConfirm/commit`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
